module.exports = __webpack_public_path__ + "static/media/LokiFrame84.26bdf2b3.png";